import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const PromotionsPage = leadLazyLoad(
  () => import('./PromotionsPage'),
  module => module.PromotionsPage,
  { fallback: null, type: LeadPageType.PROMOTIONS },
);
